import React, { Component } from 'react';

class Home extends Component {
  render() {
    return (
        <div class="home">

	    <h1>This is the Home Page</h1>

	</div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js